import React from 'react';
import { IconButton, InputAdornment, Link, Stack, TextField } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useSnackbar } from '../../context/snackbar-context';

interface SupplierProfileUrlProps {
  profileUrl: string;
}

const SupplierProfileUrl = ({ profileUrl }: SupplierProfileUrlProps) => {
  const { snackbarShowMessage } = useSnackbar();
  const fullUrl = new URL(profileUrl, window.location.origin).toString();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      snackbarShowMessage('Copied to clipboard!', 'success', 3000);
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Failed to copy supplier profile URL to clipboard.', err);
      }
      snackbarShowMessage('Failed to copy URL', 'error', 3000);
    }
  };

  return (
    <Stack gap="0.43rem" alignItems="flex-start">
      <TextField
        variant="standard"
        value={fullUrl}
        label="Public Profile URL"
        fullWidth
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="Copy profile URL"
                onClick={handleCopy}
                edge="end"
                size="small"
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Link
        href={fullUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        View Public Profile
      </Link>
    </Stack>
  );
};

export default SupplierProfileUrl;
